import { useAuthMutation } from "@l2r-front/l2r-auth"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

export function useChangePasswordMutation(config = {}) {
    const url = "me/change_password/"
    return useAuthMutation(url, axiosInstance.patch, {}, config)
}
